import React from "react";
import { ClickableDropdown } from "../../design_system/components/Dropdown/Dropdown";
import { DropdownItem } from "../../design_system/components/Dropdown/DropdownItem";
import { DropdownMenu } from "../../design_system/components/Dropdown/DropdownMenu";
import { DropdownTrigger } from "../../design_system/components/Dropdown/DropdownTrigger";
import { IconButton } from "../../design_system/components/Button/Button.jsx";

const CommentDropdown = ({ commentID, prevComment, editCommentSection, deleteComment, canEdit = false, canDelete = false }) => {
    if (!canEdit && !canDelete) return null;
    return (
        <ClickableDropdown>
            <DropdownTrigger ShowHover={false} IsIconVisible={false} customStyle={{ padding: 0, cursor: 'pointer' }}>
                <IconButton
                    Size="ExtraSmall"
                    Type="Tertiary"
                    IconName="vertical-ellipsis"
                    ariaLabel="Comment actions"
                />
            </DropdownTrigger>

            <DropdownMenu customStyle={{ right: 0, left: 'auto', marginTop: 4 }}>
                {canEdit && (
                    <DropdownItem
                        onClick={() => editCommentSection(commentID, prevComment)}
                    >
                        Edit Comment
                    </DropdownItem>
                )}
                {canDelete && (
                    <DropdownItem
                        customClasses="dropdown-item-danger"
                        onClick={() => deleteComment(commentID)}
                    >
                        Delete Comment
                    </DropdownItem>
                )}
            </DropdownMenu>
        </ClickableDropdown>
    );
};

export default CommentDropdown;